import * as NUMBER from 'constant/number'
import React, { useEffect } from 'react'
import { Row, Col, Form } from 'antd'
import Editor from 'view/component/editor'
import PropTypes from 'prop-types'
import TitleInput from 'view/component/form-items/title-input'
import ShortDescriptionInput from 'view/component/form-items/short-description-input'
import OrganisationSelect from 'view/component/form-items/article-org-select'
import CategorySelect from 'view/component/form-items/category-select'
import UpdateFrequencySelect from 'view/component/form-items/update-frequency-select'
import AssociatedDataSet from 'view/component/form-items/associated-dataset'
import PublishedSelect from 'view/component/form-items/published-select'
import SpecialGroupSelect from 'view/component/form-items/article-special-group-select'
import Draft from 'view/component/form-items/draft'
import Upload from 'view/component/form-items/upload'
import UserTypeSelect from 'view/component/form-items/article-user-type-select'
import TagSelect from 'view/component/form-items/tag-select'
import Email from 'view/component/form-items/send-email-select'

const defaultFormValues = { published: false, send_emails: 'false', special: false }

// eslint-disable-next-line max-lines-per-function
const InsightForm = ({ insight = defaultFormValues, form, datasets }) => {
  useEffect(() => {
    form.setFieldsValue(insight)
  }, [insight])
  return (
    <Row gutter={NUMBER.FIFTY}>
      <Col xl={NUMBER.EIGHT}>
        <Form
          form={form}
          layout='vertical'
          onFieldsChange={(changedFields) => {
            if (changedFields[0].name[0] === 'category_uuid') {
              form.setFieldsValue({ organisation_uuids: [], special: false, tag_uuid: [], user_type_uuids: [] })
            }
            if (changedFields[0].name[0] === 'special') {
              form.setFieldsValue({ user_type_uuids: [] })
            }
          }}
        >
          <TitleInput />
          <ShortDescriptionInput />
          <AssociatedDataSet datasets={datasets} />
          <CategorySelect />
          <OrganisationSelect />
          <SpecialGroupSelect />
          <UserTypeSelect />
          <TagSelect />
          <UpdateFrequencySelect />
          <PublishedSelect />
          <Draft />
          <Upload fileName={insight.image_name} />
          <Email />
        </Form>
      </Col>
      <Col xl={NUMBER.SIXTEEN}>
        <Editor
          form={form}
          insight={insight}
        />
      </Col>
    </Row>
  )
}

InsightForm.propTypes = {
  datasets: PropTypes.object,
  form: PropTypes.object,
  insight: PropTypes.object
}

export default InsightForm
